import reducer from "./reducer";
export { default as RatingScales } from "./components/index";
export { default as ratingScalesReducerName } from "./constants";
export default reducer;
